import React from 'react';
import { Button } from 'react-bootstrap';
import WorkspacePageHeader from '../../../components/workspace/WorkspacePageHeader';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { platformAPI } from '../../../services/platformAPI';
import { downloadWorkbook } from '../../../utils/downloadWorkbook';
import { useWorkspaceAccess } from '../../../hooks/useWorkspaceAccess';
import { SecuritiesPanel } from './PursuitPanels';

const SecuritiesPage = () => {
  useDocumentTitle('BG / EMD');
  const { allowed } = useWorkspaceAccess();
  const canDownload = allowed(['securities.download', 'tender.read']);
  const download = async () => {
    const response = await platformAPI.listSecurities();
    const data = response.data?.data || {};
    downloadWorkbook('securities', [
      {
        name: 'Instruments',
        rows: (data.instruments || []).map((row) => ({
          Tender: row.tenderId || '',
          Type: row.typeLabel || '',
          Reference: row.instrumentReference || '',
          Issuer: row.issuerName || '',
          Currency: row.currency || '',
          'Original amount': row.amount ?? '',
          'Current amount': row.currentAmount ?? '',
          Status: row.displayStatus || '',
          Expiry: String(row.currentExpiryDate || row.expiryDate || '').slice(0, 10)
        }))
      },
      {
        name: 'Exposure',
        rows: (data.exposure || []).map((row) => ({
          Currency: row.currency || '',
          Amount: row.amount ?? ''
        }))
      }
    ]);
  };
  return (
    <div>
      <WorkspacePageHeader
        title="BG / EMD"
        help="securities"
        subtitle="Instruments recorded against tenders. Exposure stays in each currency. This is a register, not a bank or accounts module."
        actions={canDownload ? <Button size="sm" variant="outline-primary" onClick={download}>Export Excel</Button> : null}
      />
      <SecuritiesPanel />
    </div>
  );
};

export default SecuritiesPage;
